import jwt_decode from 'jwt-decode';
import refreshAccessToken from './refreshAccessToken';

const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};

const GetValidatedTokenData = () => {
  const token = localStorage.getItem('Token');
  const isPublicPage = window.location.pathname.startsWith('/p/');

  if (token) {
    const decodedJwt = parseJwt(token);

    if (decodedJwt?.exp * 1000 > Date.now()) {
      return {
        ...jwt_decode(token), isLoggedIn: true
      };
    }

    refreshAccessToken().catch(() => {
      localStorage.setItem('lastPage', window.location.href);
      localStorage.removeItem('Token');
      
      if(!isPublicPage) {
        window.location.href = '/sign-in';
      }
    })


    return {
      role: null, isLoggedIn: false
    };
  }

  // if (window.location.pathname !== "/sign-in")
  //   window.location.href = "/sign-in";
  // needs to be added back once we have defined routes which needs token or not
  return {
    role: null, isLoggedIn: false
  };
};

export const removeDomain = (url) => {
  try {
    const parsedUrl = new URL(url);

    return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
  } catch (error) {
    return null;
  }
};

export default GetValidatedTokenData;
